
<template>
  <div class="shopkeeper-help">
    <component :is="$store.state.device"></component>
  </div>
</template>

<script>
import m from './device/m.vue'
import pc from './device/pc.vue'

export default {
  name: 'shopkeeper-help',

  components: {
    pc,
    m
  }
}
</script>
